
//CORE
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import TrafficRoundedIcon from '@material-ui/icons/TrafficRounded';
import LibraryBooksRoundedIcon from '@material-ui/icons/LibraryBooksRounded';
import SettingsIcon from '@material-ui/icons/Settings';
import EventNoteRoundedIcon from '@material-ui/icons/EventNoteRounded';
import InsertChartRoundedIcon from '@material-ui/icons/InsertChartRounded';
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';
import SchoolRoundedIcon from '@material-ui/icons/SchoolRounded';
import MenuBookRoundedIcon from '@material-ui/icons/MenuBookRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import { Container } from './ui';
import ListarHorario from './ListarHorario';
import Semaforo from './Semaforo';
import ListarNotas from './ListarNotas';
import ListarSyllabus from "./ListarSyllabus";
import ListarRubrica from "./ListarRubrica";
import ListarModalidades from './ListarModalidades';
import SetupPrograma from './SetupPrograma';
import { consulta, validarUsuarioApp, obtenerValoresFiltros, coloresEmma } from '../../global/js/funciones';
import { mostrarModulo } from '../../redux/actions/actGlobal';

const DIAS_COMPLETOS = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

function numDiaHoy() {
    const iso = new Date().getDay();
    return iso === 0 ? 1 : iso + 1;
}

function fechaHoyTexto() {
    const hoy = new Date();
    return `${DIAS_COMPLETOS[hoy.getDay()]}, ${hoy.getDate()} de ${MESES[hoy.getMonth()]}`;
}

const TarjetaBase = ({ children, style, onClick }) => (
    <div
        onClick={onClick}
        style={{
            backgroundColor: '#fff',
            borderRadius: 16,
            border: `1px solid ${coloresEmma.fondocolor}`,
            boxShadow: '0 4px 14px rgba(0,0,0,0.07)',
            padding: 20,
            boxSizing: 'border-box',
            cursor: onClick ? 'pointer' : 'default',
            ...style,
        }}
    >
        {children}
    </div>
);

const IconoBadge = ({ Icon, chico }) => (
    <div
        style={{
            width: chico ? 34 : 40,
            height: chico ? 34 : 40,
            borderRadius: chico ? '50%' : 12,
            backgroundColor: chico ? coloresEmma.fondocolor : coloresEmma.primarycolor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: chico ? coloresEmma.primarycolor : '#fff',
            flexShrink: 0,
        }}
    >
        <Icon style={{ fontSize: chico ? 18 : 20 }} />
    </div>
);

const AnilloProgreso = ({ percent }) => {
    const radio = 46;
    const circunferencia = 2 * Math.PI * radio;
    const valor = isNaN(percent) ? 0 : Math.max(0, Math.min(100, Math.round(percent)));
    const offset = circunferencia * (1 - valor / 100);
    return (
        <div style={{ position: 'relative', width: 110, height: 110, flexShrink: 0 }}>
            <svg width={110} height={110}>
                <circle cx={55} cy={55} r={radio} stroke={coloresEmma.fondocolor} strokeWidth={8} fill="none" />
                <circle
                    cx={55}
                    cy={55}
                    r={radio}
                    stroke={coloresEmma.primarycolor}
                    strokeWidth={8}
                    fill="none"
                    strokeDasharray={circunferencia}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    transform="rotate(-90 55 55)"
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <span style={{ fontSize: 9, fontWeight: 700, color: coloresEmma.gray, letterSpacing: 0.4 }}>TU PROGRESO</span>
                <span style={{ fontSize: 22, fontWeight: 800, color: '#222' }}>{valor}%</span>
            </div>
        </div>
    );
};

const BotonAccion = ({ Icon, texto, onClick }) => (
    <TarjetaBase
        onClick={onClick}
        style={{ display: 'flex', alignItems: 'center', gap: 12, flex: '1 1 220px', padding: '14px 16px' }}
    >
        <IconoBadge Icon={Icon} />
        <span style={{ fontWeight: 700, color: '#222', flex: 1 }}>{texto}</span>
        <ChevronRightRoundedIcon style={{ color: coloresEmma.gray }} />
    </TarjetaBase>
);

const FilaResumen = ({ Icon, etiqueta, valor }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0' }}>
        <IconoBadge Icon={Icon} chico />
        <span style={{ flex: 1, color: '#444' }}>{etiqueta}</span>
        <span style={{ fontWeight: 800, color: coloresEmma.primarycolor, fontSize: 18 }}>{valor}</span>
    </div>
);

const FilaClaseHoy = ({ clase }) => {
    const detalle = clase.detalle || {};
    return (
        <div style={{ display: 'flex', gap: 12, padding: '10px 0', borderBottom: `1px solid ${coloresEmma.fondocolor}` }}>
            <div style={{ width: 4, borderRadius: 2, backgroundColor: coloresEmma.primarycolor, flexShrink: 0 }} />
            <div>
                <div style={{ fontWeight: 700, color: '#222' }}>{clase.asignatura}</div>
                <div style={{ fontSize: 12, color: coloresEmma.gray, marginTop: 2 }}>
                    {clase.hora_inicio} - {clase.hora_fin} {detalle.salon ? `· ${detalle.salon}` : ''}
                </div>
            </div>
        </div>
    );
};

class Consultas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            resumen: {},
            rubrica: {},
            modalRubrica: false,
            dialogHorario: false,
            dialogSemaforo: false,
            dialogNotas: false,
            dialogPlan: false,
            dialogSyllabus: false,
            setupPrograma: false,
            horario: [],
            syllabus: [],
            semaforo: {},
            age: "",
            current_user: {},
            programas: [],
            programa: '',
            loading: false,
            dataModal: '',
            dataPlan: {},
            statePlan: 0,
            indice: 1,
            modalidades: [],
            cargandoHorario: false,
            cargandoSemaforo: false,
            cargandoNotas: false,
        };

        this.toggleDialog = this.toggleDialog.bind(this)
        this.obtenerPlan = this.obtenerPlan.bind(this)
        this.obtenerSemaforo = this.obtenerSemaforo.bind(this)
        this.obtenerSyllabus = this.obtenerSyllabus.bind(this)
        this.obtenerHorario = this.obtenerHorario.bind(this)
        this.cargarHorarioHoy = this.cargarHorarioHoy.bind(this)
        this.obtenerNotas = this.obtenerNotas.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    async componentDidMount() {
        let { mostrarModulo } = this.props;
        mostrarModulo({ ruta: '/consultas', nombre: 'consultas' });
        let validarUsuario = await validarUsuarioApp();
        if (validarUsuario.estado === 200) this.setState({ current_user: validarUsuario.resp })
        await this.obtenerProgramas();
        await this.obtenerInfo();
        this.cargarHorarioHoy();
    }

    obtenerInfo() {
        const { programa } = this.state;
        this.setState({ loading: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/obtenerInfo`, { programa: programa.codigo }, "post", (error, estado, resp) => {
                this.setState({ resumen: resp || {} })
                this.setState({ loading: false })
                resolve(true);
            })
        })
    }

    cargarHorarioHoy() {
        const { programa } = this.state;
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/horario?programa=${programa.codigo}`, null, null, (error, estado, resp) => {
                this.setState({ horario: (resp && resp.horario) || [] })
                resolve(true)
            })
        })
    }

    obtenerHorario() {
        const { programa } = this.state;
        this.toggleDialog({ modal: 'dialogHorario', value: true })
        this.setState({ cargandoHorario: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/horario?programa=${programa.codigo}`, null, null, (error, estado, resp) => {
                this.setState({ horario: (resp && resp.horario) || [], cargandoHorario: false })
                resolve(true)
            })
        })
    }

    obtenerSemaforo() {
        this.toggleDialog({ modal: 'dialogSemaforo', value: true })
        this.setState({ cargandoSemaforo: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/semaforo`, null, null, (error, estado, resp) => {
                this.setState({ semaforo: (resp && resp.semaforo) || {}, cargandoSemaforo: false })
                resolve(true)
            })
        })
    }

    async obtenerNotas() {
        this.toggleDialog({ modal: 'dialogNotas', value: true })
        this.setState({ cargandoNotas: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/modalidades`, null, null, (error, estado, resp) => {
                this.setState({ modalidades: (resp && resp.modalidades) || [], cargandoNotas: false })
                resolve(true)
            })
        })
    }

    obtenerSyllabus() {
        this.setState({ loading: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/syllabus`, null, null, (error, estado, resp) => {
                this.setState({ Syllabus: " " })
                this.toggleDialog({ modal: 'dialogSyllabus', value: true })
                this.setState({ loading: false })
                resolve(true)
            })
        })
    }

    obtenerProgramas() {
        const { current_user } = this.state

        return new Promise(resolve => {
            consulta(`api/v1.0/personas/${current_user.id}/genericas/${3}`, null, null, (error, estado, resp) => {
                let programas = resp.map(item => item.relacion);
                this.setState({ programas })
                this.setState({ programa: programas[0] })
                resolve(true)
            })
        })
    }

    obtenerPlan() {
        this.setState({ loading: true })
        return new Promise(resolve => {
            consulta(`api/v1.0/consultas/horario`, null, null, (error, estado, resp) => {
                this.setState({ horario: resp.horario })
                this.toggleDialog({ modal: 'dialogPlan', value: true })
                this.setState({ loading: false })
                resolve(true)
            })
        })
    }

    toggleDialog(toggle) {
        let { modal, value, data } = toggle
        this.setState({ [modal]: value, dataModal: data })
    }


    async handleChange({ target }) {
        const { programas } = this.state;
        const newPrograma = await programas.find(({ codigo }) => codigo === target.value)
        await this.setState({ programa: newPrograma })
        this.obtenerInfo();
    }

    render() {
        const { resumen, dialogSemaforo, semaforo, current_user, programas, programa, dialogNotas, loading, dialogHorario, horario, setupPrograma, modalidades, dialogSyllabus, syllabus, dataModal, dialogPlan, indice, cargandoHorario, cargandoSemaforo, cargandoNotas } = this.state;

        const clasesHoy = (horario || []).filter((h) => parseInt(h.num_dia, 10) === numDiaHoy());
        const semestre = resumen.semestre_creditos && resumen.semestre_creditos.length !== 0 ? resumen.semestre_creditos[2] : 0;
        const creditos = resumen.semestre_creditos && resumen.semestre_creditos.length !== 0 ? resumen.semestre_creditos[3] : 0;

        return (
            <Container loading={loading}>
                <div style={{ width: '100%', backgroundColor: '#fff', paddingTop: 70, paddingBottom: 50 }}>
                <div style={{ width: '100%', maxWidth: 960, margin: '0 auto', padding: '0 20px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 26 }}>

                    <TarjetaBase style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
                        <div>
                            <div style={{ fontSize: 24, fontWeight: 800, color: '#222' }}>Hola, {current_user.primer_nombre}! 👋</div>
                            <div style={{ color: coloresEmma.gray, marginTop: 6 }}>Bienvenido al resumen y estado de tu programa</div>
                            <div style={{ color: coloresEmma.primarycolor, fontWeight: 800, marginTop: 4, textTransform: 'uppercase' }}>{programa.nombre}</div>
                        </div>
                        <AnilloProgreso percent={resumen.porcentaje} />
                    </TarjetaBase>

                    <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                        <BotonAccion Icon={InsertInvitationRoundedIcon} texto="Horario" onClick={this.obtenerHorario} />
                        <BotonAccion Icon={TrafficRoundedIcon} texto="Semaforo" onClick={this.obtenerSemaforo} />
                        <BotonAccion Icon={LibraryBooksRoundedIcon} texto="Notas" onClick={this.obtenerNotas} />
                    </div>

                    <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                        <TarjetaBase style={{ flex: '1 1 400px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <IconoBadge Icon={EventNoteRoundedIcon} />
                                <div>
                                    <div style={{ fontWeight: 700, color: '#222' }}>Clases de hoy</div>
                                    <div style={{ fontSize: 12, color: coloresEmma.gray, textTransform: 'capitalize' }}>{fechaHoyTexto()}</div>
                                </div>
                            </div>

                            {clasesHoy.length === 0 ? (
                                <div style={{ backgroundColor: '#f5f6f7', borderRadius: 12, padding: '24px 16px', textAlign: 'center', marginTop: 16 }}>
                                    <EventNoteRoundedIcon style={{ fontSize: 32, color: coloresEmma.gray }} />
                                    <div style={{ color: coloresEmma.gray, marginTop: 6 }}>No tienes clases programadas para hoy.</div>
                                </div>
                            ) : (
                                <div style={{ marginTop: 14 }}>
                                    {clasesHoy.map((clase, i) => (
                                        <FilaClaseHoy key={i} clase={clase} />
                                    ))}
                                </div>
                            )}

                            <div
                                onClick={this.obtenerHorario}
                                style={{ marginTop: 14, color: coloresEmma.primarycolor, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
                            >
                                Ver horario completo <ArrowForwardRoundedIcon style={{ fontSize: 18 }} />
                            </div>
                        </TarjetaBase>

                        <TarjetaBase style={{ flex: '1 1 300px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                                <IconoBadge Icon={InsertChartRoundedIcon} />
                                <span style={{ fontWeight: 700, color: '#222' }}>Resumen academico</span>
                            </div>
                            <FilaResumen Icon={AllInboxRoundedIcon} etiqueta="Promedio acumulado" valor={resumen.promedio_acumulado || '0.0'} />
                            <FilaResumen Icon={SchoolRoundedIcon} etiqueta="Promedio nivel" valor={resumen.promedio_nivel || '0.0'} />
                            <FilaResumen Icon={MenuBookRoundedIcon} etiqueta="Semestre" valor={semestre} />
                            <FilaResumen Icon={LibraryBooksRoundedIcon} etiqueta="Creditos matriculados" valor={creditos} />
                        </TarjetaBase>
                    </div>

                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                            <SettingsIcon style={{ color: coloresEmma.primarycolor }} />
                            <span style={{ fontWeight: 700, fontSize: 18, color: '#222' }}>Preferencias</span>
                        </div>
                        <TarjetaBase
                            style={{ display: 'flex', alignItems: 'center', gap: 14 }}
                            onClick={() => this.toggleDialog({ modal: 'setupPrograma', value: true })}
                        >
                            <IconoBadge Icon={SettingsIcon} />
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 700, color: '#222' }}>Programa</div>
                                <div style={{ fontSize: 12, color: coloresEmma.gray }}>Haz click aqui para cambiar el programa</div>
                            </div>
                            <ChevronRightRoundedIcon style={{ color: coloresEmma.gray }} />
                        </TarjetaBase>
                    </div>
                </div>
                </div>

                <Semaforo status={dialogSemaforo} toggle={this.toggleDialog} data={semaforo} cargando={cargandoSemaforo} />
                <ListarModalidades status={dialogNotas} toggle={this.toggleDialog} data={modalidades} current_user={current_user} cargando={cargandoNotas} />
                <SetupPrograma status={setupPrograma} toggle={this.toggleDialog} programas={programas} programa={programa.codigo} handleChange={this.handleChange} />
                <ListarHorario setModalRubrica={(modalRubrica) => this.setState({ modalRubrica })} status={dialogHorario} toggle={this.toggleDialog} data={horario} cargando={cargandoHorario} setDataPlan={(dataPlan) => this.setState({ dataPlan, statePlan: this.state.statePlan + 1 })} setIndice={(indice) => this.setState({ indice })} />
                <ListarSyllabus statePlan={this.state.statePlan} dataPlan={this.state.dataPlan} status={dialogSyllabus} toggle={this.toggleDialog} data={syllabus} Modal={dataModal} />
                <ListarRubrica statePlan={this.state.statePlan} dataPlan={this.state.dataPlan} setModalRubrica={(modalRubrica) => this.setState({ modalRubrica })} modalRubrica={this.state.modalRubrica} indice={indice} />
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    mostrarModulo,
};

Consultas.propTypes = {
    mostrarModulo: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Consultas);
